module.exports = __webpack_public_path__ + "img/fire.43671b32.png";